import "../../../../src/content/ethiopia-livestream/ethiopia.scss";
import * as React from 'react';
export default {
  React
};